import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchActiveCustomers } from '../../actions/customers_actions';
import {
  fetchSalesOdersByDate, voidSalesOrder, fetchSalesOrders, fetchSalesOrderDetail,
  selectSalesOrder, resetCurrentSalesOrder, setSalesOrdersFilter, setValue,
  fetchSalesOrdersByFilter, loadsPost
} from '../../actions/sales_actions';
import { fetchPosOrdersByDate, fetchPosOrders, fetchPosOrderDetail, fetchPosOrdersByFilter, voidPosOrder } from '../../actions/pos_actions';
import { setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import PosOrders from '../../components/Sales/posOrders';
import { ROOT_API_URL } from '../../actions/root_url';
const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';

const posOrders = reduxForm({
  form: 'posOrders',
  destroyOnUnmount: false,
})(PosOrders);

const selector = formValueSelector('posOrders');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Status = selector(state, 'Status');
  const Seller = selector(state, 'Seller');
  const ProductNum = selector(state, 'ProductNum');
  const Customer = selector(state, 'Customer');
  const Type = selector(state, 'Type');
  
  return {
    Days,
    FromDate,
    ToDate,
    Status,
    Seller,
    ProductNum,
    Customer,
    Type,
    currentPosOrder: state.salesOrders.currentSalesOrder,
    posOrders: isEcity ? ((state.pos.all!==null) ? state.pos.all.records : []) : state.pos.all,
    posOrdersAll: state.pos.all,
    isLoading: state.pos.isLoading,
    error: state.pos.error,
    posOrderDetail: state.pos.currentPosOrderDetail,
    posOrderIsLoading: state.pos.detailIsLoading,
    posOrderError: state.pos.detailError,
    posOrdersFilter: state.salesOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    
    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
    
    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,
    
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  fetchSalesOdersByDate,
  voidSalesOrder,
  fetchSalesOrders,
  fetchSalesOrderDetail,
  selectSalesOrder,
  fetchActiveCustomers,
  resetCurrentSalesOrder,
  loadsPost,
  setSalesOrdersFilter,
  setValue,
  fetchBaseUsers,
  setDefaultOfForm,
  fetchSalesOrdersByFilter,
  fetchPosOrdersByDate,
  fetchPosOrders,
  fetchPosOrderDetail,
  fetchPosOrdersByFilter,
  voidPosOrder,
  checkPassword,
  clearCheckPassword,
})(posOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/posOrders.jsx